/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryNoteBundle } from '../../models/delivery-note-bundle';
import { KeyType } from '../../models/key-type';

export interface GetBundle$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The delivery note bundle key
 */
  deliveryNoteBundleKey: KeyType;
}

export function getBundle(http: HttpClient, rootUrl: string, params: GetBundle$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryNoteBundle>> {
  const rb = new RequestBuilder(rootUrl, getBundle.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteBundleKey', params.deliveryNoteBundleKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryNoteBundle>;
    })
  );
}

getBundle.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-note-bundles/{deliveryNoteBundleKey}';
